import React, { useState } from 'react';
import { LIBRARY_ALL, SHELVES } from '../../data/howShelves';
const FORCE_TONE = {
  MUST: 'var(--ink)',
  NEVER: 'var(--red)',
  SHOULD: 'var(--amber)'
} as const;

/** A mock of the library view: shelves on the rail, expandable rows on the right. */
export function LibraryShelves() {
  const [open, setOpen] = useState<string | null>('regulatory');
  return <div className="lib" data-id="element-168" data-mp="2rh269103mlmr">
      <div className="win-bar" data-id="element-169" data-mp="2rgiwi7klr3jt">
        <div className="dots" aria-hidden="true" data-id="element-170" data-mp="2rhkaokwx065r">
          <i data-id="element-171" data-mp="2mi7rca595h7x" />
          <i data-id="element-172" data-mp="2miqweq9t0b4j" />
          <i data-id="element-173" data-mp="2mj0n6g2oamba" />
        </div>
        <div className="win-url" data-id="element-174" data-mp="2mjsirqw9sk1k">
          app.meetsynthia.ai<span data-id="element-175" data-mp="309vx7vowr9gg">/</span>library
        </div>
        <div className="lib-tag" data-id="element-176" data-mp="30anmkorwwaya">PHARMA PILOT · DAY 41</div>
      </div>
      <div className="lib-g" data-id="element-177" data-mp="2vhkyux9tfvq0">
        <div className="lib-rail" data-id="element-178" data-mp="2vhckf0y1oicp">
          <div className="lib-rh" data-id="element-179" data-mp="27sth6ztuqvrh">SHELVES</div>
          <button type="button" className={`lib-ri${open === null ? ' all' : ''}`} onClick={() => setOpen(null)} data-id="element-180" data-mp="27riaos90v9wo">
            <span className="nm" data-id="element-181" data-mp="23r7xauiwhh7s">All</span>
            <span className="c" data-id="element-182" data-mp="3vb6lcislqlln">{LIBRARY_ALL}</span>
          </button>
          {SHELVES.map(s => <button key={s.id} type="button" className={`lib-ri${open === s.id ? ' on' : ''}`} aria-pressed={open === s.id} onClick={() => setOpen(s.id)} data-id="element-183" data-mp="43u649ba4i8d">
              <span className="nm" data-id="element-184" data-mp="8x5bs74cusyp">
                <i style={{
              background: s.dot
            }} aria-hidden="true" data-id="element-185" data-mp="duoqf84yt7r6" />
                {s.name}
              </span>
              <span className="c" data-id="element-186" data-mp="3cckgcstysacg">{s.count}</span>
            </button>)}
        </div>
        <div className="lib-t" data-id="element-187" data-mp="3ha2l070y83en">
          <div className="lib-row h" data-id="element-188" data-mp="3hbdvepowg9eq">
            <span data-id="element-189" data-mp="3m9yrccx4c6xd">SHELF</span>
            <span data-id="element-190" data-mp="3m8xbzw92ky9u">WHAT’S ON IT</span>
            <span style={{
            textAlign: 'right'
          }} data-id="element-191" data-mp="3m8nnkd3oaz69">RULES</span>
            <span data-id="element-192" data-mp="3ra369yidotlh">SOURCE</span>
          </div>
          {SHELVES.map(s => {
          const isOpen = open === s.id;
          return <div key={s.id} data-id="element-193" data-mp="11lu3xgnfnnyb">
                <button type="button" className={`lib-row b${isOpen ? ' open' : ''}`} aria-expanded={isOpen} aria-controls={`shelf-${s.id}`} onClick={() => setOpen(isOpen ? null : s.id)} data-id="element-194" data-mp="16ikn4cujazny">
                  <span className="nm" data-id="element-195" data-mp="3bmdnw9w3es4j">
                    <span className="chev" aria-hidden="true" data-id="element-196" data-mp="3blcfyeadilr1">
                      ›
                    </span>
                    {s.name}
                  </span>
                  <span className="w" data-id="element-197" data-mp="2juy6cu9e7vl6">{s.what}</span>
                  <span className="n" data-id="element-198" data-mp="2jvpszfl0iizb">{s.count}</span>
                  <span className="src" style={{
                color: s.sourceTone
              }} data-id="element-199" data-mp="2ex63j577mp27">
                    {s.source}
                  </span>
                </button>
                {isOpen && <div className="lib-rules" id={`shelf-${s.id}`} data-id="element-200" data-mp="2nxb6n35df1ak">
                    {s.rules.map(r => <div className="lib-rule" key={r.rule} data-id="element-201" data-mp="206p2hmyhm15u">
                        <span className="f" style={{
                  color: FORCE_TONE[r.force],
                  borderColor: FORCE_TONE[r.force]
                }} data-id="element-202" data-mp="20547jw89gg7g">
                          {r.force}
                        </span>
                        <span className="r" data-id="element-203" data-mp="1lzvha6a6ao5s">{r.rule}</span>
                        <span className="m" data-id="element-204" data-mp="1qtqac0bo4fhj">
                          trigger: {r.trigger}
                        </span>
                        <span className="m" data-id="element-205" data-mp="1c5bzb243lkpw">{r.source}</span>
                      </div>)}
                    <div className="lib-more" data-id="element-206" data-mp="1h352rne0o0mh">
                      showing {s.rules.length} of {s.count} · versions and triggers on every one
                    </div>
                  </div>}
              </div>;
        })}
        </div>
      </div>
    </div>;
}